// For full API documentation, including code examples, visit https://wix.to/94BuAAs
import wixWindow from 'wix-window'
import wixLocation from 'wix-location';
import { local } from 'wix-storage';
import { getUserDetails } from 'public/wixUsers';
// import { memory } from 'wix-storage';
let baseUrl = wixLocation.baseUrl;


// let formFactor = wixWindow.formFactor;

const mobile = wixWindow.formFactor === "Mobile";

$w.onReady(function () {
    console.log("checkUSER");

    getUserDetails().then(user => {
            console.log(user)
            let savedUserEmail = user.email
            let savedUserId = user.guid


        })

        .catch((err) => {
            console.log("not a user");
            // $w("#boxLightbox").show()

            // let boolUserSawBannner = memory.getItem("userSawBanner"); // "value"
            // setTimeout(function () {
            //     if (boolUserSawBannner === null) {
            //         memory.setItem("userSawBanner", "true");
            //         if (formFactor !== "Mobile") {
            //             wixWindow.openLightbox("signUp");
            //         }
            //     }
            // }, 3000);

            let errMsg = err.message;
            let errCode = err.code;
        });

    const searhBtn = $w('#searchIcon');

    searhBtn.onClick((event) => {
        searchIcon_click();
    })

    $w('#inputSearcHeader').onKeyPress((e) => {
        if (e.key === "Enter" || e.code === 13) {
            let valueToSearch = $w('#inputSearcHeader').value
            local.setItem('searchValue', valueToSearch)
            wixLocation.to('https://www.wix.com/encyclopedia/results-page')
        }
    })
});

let slideOptions = {
    "duration": 300,
    "delay": 0,
    "direction": "right"
};

function searchIcon_click(event) {
    if (wixWindow.formFactor === 'Desktop') {
        toggleSearchInput();
    } else {
        let valueToSearch = $w('#inputSearcHeader').value
        local.setItem('searchValue', valueToSearch)
        wixLocation.to('https://www.wix.com/encyclopedia/results-page')
    }

}

let inputDisplay = false

function toggleSearchInput() {

    if (inputDisplay) {
        //$w("#inputSearcHeader").hide("slide", slideOptions);
        inputDisplay = false;
        let valueToSearch = $w('#inputSearcHeader').value
        if (valueToSearch.length > 0) {
            local.setItem('searchValue', valueToSearch)
            wixLocation.to('https://www.wix.com/encyclopedia/results-page')
        }

    } else {
        //$w("#inputSearcHeader").show("slide", slideOptions);
        inputDisplay = true;
        setTimeout(() => {
            $w('#inputSearcHeader').focus();
        }, 350);
    }
}



